export const initAppForPage = async () => {
  return {};
};
